import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import ContactsHeader from "../components/contacts/ContactsHeader";
import ContactsTable from "../components/contacts/ContactsTable";
import { DebugElement } from "../Atollon/debug";
import { TouchPageHeader, TouchPageHeader_and_content_spaceBetween } from "../AtollonTheme/ReactElements";
import { array_utilities } from "../Atollon/utilities/array_utilities";
import { filter, size, concat } from "lodash";

import {
    getContacts,
    getProviders,
    getClients,
    getDispatchers
} from "../actions/resourceActions";

const Contacts = ({ match, history, state }) =>
{
    const { resource: { providers, contacts, dispatchers, clients }, searchBar } = state;

    let selectedArray = null;
    let allArray = null;
    let suppliersArray = null;
    let clientsArray =  null;
    {
        let contactsDataArray = contacts && contacts.item; // javascript short circuit to select subelement
        let suppliersDataArray = providers && providers.item; // javascript short circuit to select subelement
        let clientsDataArray = clients && clients.item; // javascript short circuit to select subelement
        let dispatchersDataArray = dispatchers && dispatchers.item; // javascript short circuit to select subelement

        const sortedAndFilteredArray = ( searchBar, array ) =>
        {
            return array_utilities.array_of_structs_locale_sort_by_array_of_field_names(
                filter( array, (item) =>
                {
                    if( searchBar.searchText )
                    {
                        let matches = ( string ) => {
                            return string && string.toLocaleLowerCase().match( searchBar.searchText.toLocaleLowerCase() );
                        };
                        let match = matches( item.identifier ) || matches( item.name );
                        return match;
                    }
                    else
                    {
                        return true;
                    }
                }),
                ['name','identifier']
            );
        };

        const matchUrl = ( url ) =>
        {
            return window.location.pathname === url;
        };

        suppliersArray = concat( sortedAndFilteredArray( searchBar, suppliersDataArray ), sortedAndFilteredArray( searchBar, dispatchersDataArray ));
        clientsArray = [...sortedAndFilteredArray( searchBar, clientsDataArray ), ... sortedAndFilteredArray( searchBar, dispatchersDataArray )];
        allArray = [...sortedAndFilteredArray( searchBar, contactsDataArray )];

        if( matchUrl(`${match.url}/suppliers`))
        {
            selectedArray = suppliersArray;
        }
        else if( matchUrl(`${match.url}/clients`))
        {
            selectedArray = clientsArray;
        }
        else // `${match.url}`
        {
            selectedArray = allArray;
        }
    }

  return (
    <div className="">
        <TouchPageHeader title={"Kontakty"}/>
        <TouchPageHeader_and_content_spaceBetween heightPx={45}/>
        <DebugElement text={"src/containers/Contacts.js"}/>
        <ContactsHeader
            history={history}
            buttons={[
                { label: "Všechny kontakty", link: `${match.url}`, exact: true, array: allArray },
                { label: "Dodavatelé", link: `${match.url}/suppliers`, array: suppliersArray },
                { label: "Klienti", link: `${match.url}/clients`, array: clientsArray }
            ]}
            array={selectedArray}
        />
        <div style={{height: '25px'}} />
        <ContactsTable history={history} match={match} array={selectedArray} />
    </div>
  );
};

export default compose(
    connect(
        ( state ) => { return { state }},
        { getContacts, getProviders, getClients, getDispatchers }
    ),
    lifecycle({
        async componentWillMount()
        {
            const {
                getContacts,
                getProviders,
                getClients,
                getDispatchers
            } = this.props;

            getProviders();
            getDispatchers();
            getClients();
            getContacts();
        }
    })
)( Contacts );



// WEBPACK FOOTER //
// ./src/pages/Contacts.js